var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled, { css } from "styled-components";
import Heading from "@nib-components/heading";
import { copyColor } from "@nib-components/theme";
import { Margin, mb } from "styled-components-spacing";
import { map } from "styled-components-breakpoint";
import { pickColor, validColorValues } from "@nib/layout";
export var validTitleValues = ["h1", "h2", "h3", "h4", "h5", "h6", "div", "label", "span", "header"];
var FeatureWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  height: 100%;\n  text-align: center;\n"]))); // eslint-disable-next-line @typescript-eslint/no-unused-vars

var IconWrapper = styled(function (_ref) {
  var display = _ref.display,
      iconFill = _ref.iconFill,
      rest = _objectWithoutProperties(_ref, ["display", "iconFill"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ", ";\n"])), mb(5), function (_ref2) {
  var iconFill = _ref2.iconFill;
  return iconFill && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), pickColor(iconFill));
}, function (_ref3) {
  var display = _ref3.display;
  return map(display, function (val) {
    return val ? "display: block;" : "display: none;";
  });
});
export var Content = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  max-width: 30em;\n  margin: auto;\n  font-family: ", ";\n  color: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts && theme.fonts.sansSerif || theme.fonts.copy || "sans-serif";
}, copyColor);

var Feature = function Feature(props) {
  var Icon = props.icon,
      iconFill = props.iconFill,
      displayIcons = props.displayIcons,
      title = props.title,
      _props$titleComponent = props.titleComponent,
      titleComponent = _props$titleComponent === void 0 ? "h3" : _props$titleComponent,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["icon", "iconFill", "displayIcons", "title", "titleComponent", "children"]);

  var featureTitle = title && /*#__PURE__*/React.createElement(Margin, {
    bottom: 5
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 4,
    component: titleComponent
  }, title));
  return /*#__PURE__*/React.createElement(FeatureWrapper, otherProps, /*#__PURE__*/React.createElement(IconWrapper, {
    display: displayIcons,
    iconFill: iconFill
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "xl"
  })), featureTitle, /*#__PURE__*/React.createElement(Content, null, children));
};

Feature.displayName = "FeaturePanel.Feature";
export default Feature;